console.log("Sprint 0");
console.log("test");
//NOTE: This makes sure the component can be rendered by the browser
export * from "./components/GameCanvas";
